import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            /* background: #f8f5f3; */
            min-height: 300px;
            margin: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            border: 1px solid #e5e5e5;
            img {
                height: auto;
                max-width: 100%;
                width: auto;
                max-height: 434px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,

                    [
                        css`
                        min-height: 300px;
                        height: 300px;
                        img {
                            height: 100%;
                            max-width: 100%;
                            width: auto;
                            max-height: none;
                        }
                        `,
                        null,
                        css`
                        min-height: 300px;
                        height: 300px;
                        img {
                            height: 100%;
                            max-width: 100%;
                            width: auto;
                            max-height: none;
                        }
                        `,
                        css`
                        min-height: 300px;
                        height: 300px;
                        img {
                            height: 100%;
                            max-width: 100%;
                            width: auto;
                            max-height: none;
                        }
                        `,
                        null,
                    ],

                    "max",
                )}
        `,
    },
};
